import { type ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LogtoProvider } from "@logto/react";
import { getLogtoConfig } from "@/services/auth/logto";
import { LogtoAdminProvider } from "@/services/auth/logto-provider";
import "@/i18n";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const logtoConfig = getLogtoConfig();

export function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <LogtoProvider config={logtoConfig}>
        <LogtoAdminProvider>{children}</LogtoAdminProvider>
      </LogtoProvider>
    </QueryClientProvider>
  );
}
